var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"hide-footer":_vm.unsavedError,"busy":_vm.unsavedError,"hide-header":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }